export type RealtimeVoiceNegotiationCredential = {
  negotiationToken: string;
  negotiationUrl: string;
  model: string;
};

export function buildRealtimeVoiceProviderConnectOptions(
  credential: RealtimeVoiceNegotiationCredential
) {
  return {
    apiKey: credential.negotiationToken,
    model: credential.model,
    url: credential.negotiationUrl,
  };
}
